import { useQContent } from '@exam-management/common/qcontent-provider';
import { NavigateBackLinkWithHistory, QContentStatusTag } from '@exam-management/components';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { ItemSetSubQuestionNavigationTabs } from '@exam-management/qcontent-management';
import { EllipsisText, Flex, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export default function ItemSetSubQuestionDetailHeader() {
  const { qBankStructureInformation } = useQBankStructure();
  const { code, name: qbsName, id } = qBankStructureInformation;

  const { qContent } = useQContent();
  const { updatedAt, refCode, status } = qContent;

  return (
    <PageHeader
      title={`${refCode}`}
      linkAdornment={
        <NavigateBackLinkWithHistory
          fallbackPath='/qbank-structures/:structureId/qcontents'
          matchPatterns={[
            '/qbank-structures/:structureId/qcontents',
            '/qbank-structures/:structureId/qcontents/item-set/:questionId',
          ]}
          fallbackParams={{ structureId: id }}
          label='Back'
        />
      }
      endAdornment={<QContentStatusTag status={status} size='large' />}
      subtitleSection={
        <>
          <Flex sx={{ gap: (theme) => theme.spacing(4), alignItems: 'center' }}>
            <EllipsisText variant='body2' maxLines={2}>{`CourseID: ${code}`}</EllipsisText>
            <EllipsisText variant='body2' maxLines={2}>
              {qbsName}
            </EllipsisText>
          </Flex>
          <Text color='text.secondary' variant='body2'>
            Last Modified: {formatDateTime(updatedAt)}
          </Text>
        </>
      }
      tabs={<ItemSetSubQuestionNavigationTabs questionStatus={status} />}
    />
  );
}
